import { useContext, useEffect } from 'react';
import { WebSocketContext } from './WebSocketProvider';
// PUBLIC API
export function useSocket() {
    return useContext(WebSocketContext);
}
// PUBLIC API
export function useSocketListener(event, handler) {
    const { socket } = useContext(WebSocketContext);
    useEffect(() => {
        // Casting to `keyof ServerToClientEvents` is necessary because TypeScript
        // reports the handler function as incompatible with the event type.
        // See https://github.com/wasp-lang/wasp/pull/1203#discussion_r1232068898
        socket.on(event, handler);
        return () => {
            socket.off(event, handler);
        };
    }, [event, handler]);
}
//# sourceMappingURL=index.js.map